import { defineComponent as _defineComponent } from 'vue'
import PriceDisplay from './PriceDisplay.vue';
import PriceSavings from './PriceSavings.vue';
import PriceToolTip from './PriceToolTip.vue';
import VisuallyHidden from '../VisuallyHidden.vue';
import { computed } from 'vue';
import { IProductPrice } from '../../types/Product';
import { useBreakpoints } from 'JS/composables/breakpoint';

type PriceSize = 'small' | 'medium' | 'large' | null;



export default /*#__PURE__*/_defineComponent({
  __name: 'Price',
  props: {
    price: null,
    size: { default: null },
    isTire: { type: Boolean },
    isBattery: { type: Boolean },
    showGetQuote: { type: Boolean },
    showInStoreOnlyMessage: { type: Boolean },
    isComingSoon: { type: Boolean },
    forceMobile: { type: Boolean, default: false },
    preventTooltipOverflow: { type: Boolean },
    hideTooltip: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { price: IProductPrice, size: PriceSize, isTire?: boolean, isBattery?: boolean, showGetQuote?: boolean, showInStoreOnlyMessage?: boolean, isComingSoon?: boolean, forceMobile: boolean, preventTooltipOverflow?: boolean, hideTooltip?: boolean }



const { isMobile } = useBreakpoints();

const internalPreventTooltipOverflow = computed(() => typeof props.preventTooltipOverflow === 'boolean'
	? props.preventTooltipOverflow
	: isMobile.value
);


const hasSomeVariantsOnSale = computed((): boolean => {
	return isGroupPrice.value && props.price.hasSomeVariantsOnSale;
});

const isOnPromo = computed((): boolean => {
	return !!props.price.pricePrefixText || props.price.hasSomeVariantsOnSale;
});

const quotePrice = computed((): boolean => {
	return !!props.showGetQuote && props.price.hidePrice;
});

const priceVaries = computed((): boolean => {
	return props.showInStoreOnlyMessage && props.price.hidePrice;
});

const prefixText = computed((): string => {
	const { isClearance, pricePromoText, pricePrefixText } = props.price;

	if (isClearance) return '';

	if (isOnPromo.value) return pricePrefixText;

	return pricePromoText;
});

const prefixClasses = computed(() => {
	return [
		'price-prefix',
		{
			'promo-text': isOnPromo.value,
		}
	];
});

const wrapperClasses = computed(() => {
	return [
		'price-wrapper',
		props.size && {
			[props.size]: true,
			sized: true,
		}
	];
});

const isGroupPrice = computed(() => {
	return props.price.lowPrice && props.price.lowPrice !== '0'
		&& props.price.highPrice && props.price.highPrice !== '0';
});

const groupPriceVaries = computed(() => {
	return props.price.priceRangeBelowMap;
});

const showPrice = computed(() => {
	return !props.price.hidePrice;
});

const wordsInPriceAltText = computed((): string[] => {
	return props.price?.priceAltText?.split(' ') ?? [];
});

return { __sfc: true,props, isMobile, internalPreventTooltipOverflow, hasSomeVariantsOnSale, isOnPromo, quotePrice, priceVaries, prefixText, prefixClasses, wrapperClasses, isGroupPrice, groupPriceVaries, showPrice, wordsInPriceAltText, PriceDisplay, PriceSavings, PriceToolTip, VisuallyHidden }
}

})